var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDash4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m431 121.78v266.44c0 23.04-18.74 41.78-41.78 41.78h-266.44c-23.04 0-41.78-18.74-41.78-41.78v-266.44c0-23.04 18.74-41.78 41.78-41.78h266.44c23.04 0 41.78 18.74 41.78 41.78z",
    fill: "#ecf9fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431 121.78v266.44c0 23.04-18.74 41.78-41.78 41.78h-133.22v-350h133.22c23.04 0 41.78 18.74 41.78 41.78z",
    fill: "#d9f3fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496 271h-480c-19.844 0-19.85-30 0-30h480c19.844 0 19.85 30 0 30z",
    fill: "#58b354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496 271h-240v-30h240c19.844 0 19.85 30 0 30z",
    fill: "#00a963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m482 127v-71.659c0-13.973-11.368-25.341-25.34-25.341h-71.66c-19.832 0-19.86-30 0-30h71.66c30.514 0 55.34 24.826 55.34 55.341v71.659c0 19.832-30 19.86-30 0z",
    fill: "#001737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456.66 512h-71.66c-19.832 0-19.86-30 0-30h71.66c13.973 0 25.34-11.368 25.34-25.341v-71.659c0-19.832 30-19.86 30 0v71.659c0 30.515-24.826 55.341-55.34 55.341z",
    fill: "#001737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 127v-71.659c0-30.515 24.826-55.341 55.34-55.341h71.66c19.832 0 19.86 30 0 30h-71.66c-13.972 0-25.34 11.368-25.34 25.341v71.659c0 19.832-30 19.86-30 0z",
    fill: "#00357b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127 512h-71.66c-30.514 0-55.34-24.826-55.34-55.341v-71.659c0-19.832 30-19.86 30 0v71.659c0 13.973 11.368 25.341 25.34 25.341h71.66c19.832 0 19.86 30 0 30z",
    fill: "#00357b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.218 430h-47.575c-19.832 0-19.86-30 0-30h47.575c6.497 0 11.782-5.285 11.782-11.782v-47.574c0-19.832 30-19.86 30 0v47.574c0 23.039-18.744 41.782-41.782 41.782z",
    fill: "#001737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401 169.356v-47.574c0-6.497-5.286-11.782-11.782-11.782h-47.575c-19.832 0-19.86-30 0-30h47.575c23.038 0 41.782 18.743 41.782 41.782v47.574c0 19.832-30 19.86-30 0z",
    fill: "#001737"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#00357b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m81 169.356v-47.574c0-23.039 18.744-41.782 41.782-41.782h47.575c19.832 0 19.86 30 0 30h-47.575c-6.497 0-11.782 5.285-11.782 11.782v47.574c0 19.832-30 19.86-30 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.357 430h-47.575c-23.038 0-41.782-18.743-41.782-41.782v-47.574c0-19.832 30-19.86 30 0v47.574c0 6.497 5.286 11.782 11.782 11.782h47.575c19.832 0 19.86 30 0 30z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash4);
export default __webpack_public_path__ + "static/media/dash4.fdbac64e0582de510733ff309c43d21f.svg";
export { ForwardRef as ReactComponent };